var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCompanyDetailsStepperB2C(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 415,
    height: 426,
    viewBox: "0 0 415 426",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#425fb4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#425fb4"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_28",
    "data-name": "Group 28",
    transform: "translate(-1188 -327)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Step_1_-Personal_Details",
    "data-name": "Step 1 -Personal Details",
    transform: "translate(1261 360)",
    fill: "#425fb4",
    fontSize: 20,
    fontFamily: "IBM Plex Sans, sans-serif"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Step 1 - Personal Details")), /*#__PURE__*/React.createElement("text", {
    id: "Step_2_-_Verify_Email",
    "data-name": "Step 2 - Verify Email",
    transform: "translate(1261 547)",
    fill: "#425fb4",
    fontSize: 20,
    fontFamily: "IBM Plex Sans, sans-serif"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Step 2 - Verify Email")), /*#__PURE__*/React.createElement("text", {
    id: "Step_3_-_Upload_Your_Personal_Document",
    "data-name": "Step 3 - Upload Your Personal Document",
    transform: "translate(1261 734)",
    fill: "#425fb4",
    fontSize: 20,
    fontFamily: "IBM Plex Sans, sans-serif"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Step 3 - Upload Your Personal Document")), /*#__PURE__*/React.createElement("g", {
    id: "Group_1091",
    "data-name": "Group 1091"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26",
    "data-name": "Group 26",
    transform: "translate(25 -18)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_23",
    "data-name": "Group 23"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_12",
    "data-name": "Ellipse 12",
    cx: 26,
    cy: 26,
    r: 26,
    transform: "translate(1163 345)",
    fill: "#425fb4",
    opacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_9",
    "data-name": "Ellipse 9",
    cx: 13,
    cy: 13,
    r: 13,
    transform: "translate(1176 358)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_13",
    "data-name": "Ellipse 13",
    cx: 9,
    cy: 9,
    r: 9,
    transform: "translate(1180 362)",
    fill: "#425fb4"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_24",
    "data-name": "Group 24",
    transform: "translate(25 7)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_16",
    "data-name": "Ellipse 16",
    cx: 26,
    cy: 26,
    r: 26,
    transform: "translate(1163 507)",
    fill: "#425fb4",
    opacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_15",
    "data-name": "Ellipse 15",
    cx: 13,
    cy: 13,
    r: 13,
    transform: "translate(1176 520)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    "data-name": "Path 15",
    d: "M9,0A9,9,0,1,1,0,9,9,9,0,0,1,9,0Z",
    transform: "translate(1180 524)",
    fill: "#425fb4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_27",
    "data-name": "Group 27",
    transform: "translate(25 194)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_16-2",
    "data-name": "Ellipse 16",
    cx: 26,
    cy: 26,
    r: 26,
    transform: "translate(1163 507)",
    fill: "#425fb4",
    opacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_15-2",
    "data-name": "Ellipse 15",
    cx: 13,
    cy: 13,
    r: 13,
    transform: "translate(1176 520)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    "data-name": "Path 18",
    d: "M9,0A9,9,0,1,1,0,9,9,9,0,0,1,9,0Z",
    transform: "translate(1180 524)",
    fill: "#425fb4"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_35",
    "data-name": "Path 35",
    d: "M0,0H3V183H0Z",
    transform: "translate(1213 353)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_51",
    "data-name": "Rectangle 51",
    width: 3,
    height: 183,
    transform: "translate(1213 540)",
    fill: "url(#linear-gradient)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompanyDetailsStepperB2C);
export default __webpack_public_path__ + "static/media/companyDetailsStepperB2C.f23203d10fa2c4392e1c41b10413f158.svg";
export { ForwardRef as ReactComponent };